import { FormControl } from '@angular/forms';

export function validateUnp() {
  return (control: FormControl) => {
    const value = control.value;
    if (!value) {
      return null;
    }
    const weight = [29, 23, 19, 17, 13, 7, 5, 3];
    const lastChar = +value.substr(-1);
    const trn = value.slice(0, -1).split('');
    let checkSum = 0;

    trn.forEach((el, i) => {
      const number = +el;
      if (Number.isInteger(number)) {
        checkSum += number * weight[i];
      }
    });

    if (checkSum % 11 === lastChar) {
      return null;
    } else {
      return { invalidUnp: true };
    }
  };
}
